module.exports = __webpack_public_path__ + "static/img/product6.01a0132.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product6.png
// module id = OjyN
// module chunks = 13